import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription, of } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { PedidoDataService } from 'src/app/services/pedido-data.service';
import { PedidoCadastro } from 'src/app/models/pedido-cadastro';

import { DadoBancarioService } from 'src/app/services/dado-bancario.service';
import { Auth } from 'src/app/models/auth';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { PedidoService } from 'src/app/services/pedido.service';
import construct = Reflect.construct;
import { TipoMeioPagamentoPedidoTela } from 'src/app/shared/enums/tipo-meio-pagamento-pedido-tela.enum';
import { PedidoInfo } from 'src/app/models/pedido-info';
import { FormBuilder } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
import { timingSafeEqual } from 'crypto';
import { DepositoService } from 'src/app/services/deposito.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { GerarBoletoCadastro } from 'src/app/models/gerar-boleto-cadastro';
import { VisualizarBoletoService } from '../../../visualizar-boleto/visualizar-boleto.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { CedenteService } from 'src/app/services/cedente.service';
import { TransactionService } from 'src/app/services/transaction.service';
import { GerarPixDinamico } from 'src/app/models/request/gerar-pix-dinamico';
import { QRCodePixDinamico } from 'src/app/models/response/pix-qrcode';
import { Purchase, PurchaseResponse } from 'src/app/models/purchase';
import { Assignor } from 'src/app/models/assignor';


@Component({
    selector: 'app-nova-compra-pagamento',
    templateUrl: './nova-compra-pagamento.component.html',
    styleUrls: ['./nova-compra-pagamento.component.css']
})
export class NovacompraPagamentoComponent implements OnInit, OnDestroy {

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private modalService: NgbModal,
        private pedidoDataService: PedidoDataService,
        private alertService: NewAlertService,
        private cedenteService: CedenteService,
        private transactionService: TransactionService,
        private authenticationServide: AuthenticationService,
        private pedidoService: PedidoService,
        private depositoService: DepositoService,
        private visualizarBoletoService: VisualizarBoletoService) {

        }

    public tipoPagamento: string;
    public tipoMeioPagamentoPedidoTela = TipoMeioPagamentoPedidoTela;
    public currentPedidoValue: PedidoCadastro;
    public currentPurchaseValue: Purchase;
    public currentPedidoInfoValue: PedidoInfo;
    public currentPurchaseInfoValue: Purchase;
    public currentPurchasePaymentValue: PurchaseResponse;
    private currentUser: Auth;
    public valorTotal = 0;
    public assignorInfo: Assignor;
    public qrCodePix: QRCodePixDinamico;

    public pedidoInfo: PedidoInfo;

    public boletoGerado = '';

    ngOnInit() {
        // TipoPagamento
        // Boleto ou Transferência
        this.currentUser = this.authenticationServide.currentUserValue;
        this.currentPurchaseValue = this.pedidoDataService.currentPurchaseValue;
        this.currentPurchaseInfoValue = this.pedidoDataService.currentPurchaseInfoValue;
        this.currentPurchasePaymentValue = this.pedidoDataService.currentPurchasePaymentValue;
        this.qrCodePix = new QRCodePixDinamico();
        this.loadInfo();

        if (!this.currentUser && !this.currentPurchaseValue && !this.currentPurchaseInfoValue) {
            this.create();
        }

        //this.currentPedidoInfoValue[0].pedido.produtoDescricao = this.currentPurchaseValue.purchaseItens[0].order.productDescription;


        //this.currentPurchaseInfoValue.purchaseItens.forEach(obj => {
            /* console.log('obj.pedidoitem', this.currentPedidoValue.pedidoItens); */

          //  const info = this.currentPurchaseValue.purchaseItens.find(x => x.purchaseItemId === obj.purchaseItemId);
            //console.log('Current Pedido',this.currentPurchaseValue);

            /* obj.nome = info.nome;
            const tam = environment.TOTAL_CARACTERE_CPF - info.cpf.length;
            let str = info.cpf.toString();
            for (let i = 0; i < tam; i++) { str = '0' + str; }
            obj.cpf = str;
            obj.matricula = info.matricula;
            obj.comentario = info.comentario; */
        //});

        this.currentPurchaseValue.purchaseItens[0].order.releaseDate = new Date(this.currentPurchaseValue.purchaseItens[0].order.releaseDate);
        this.currentPurchaseValue.purchaseItens[0].order.releaseDate.setHours(this.currentPurchaseValue.purchaseItens[0].order.releaseDate.getHours() + 3);
        if (this.currentPurchaseValue.paymentMethodId==2 || this.currentPurchaseValue.paymentMethodId == 4) {
            this.tipoPagamento = this.tipoMeioPagamentoPedidoTela.Transferencia;
        } else if (this.currentPurchaseValue.paymentMethodId==1) {
            this.tipoPagamento = this.tipoMeioPagamentoPedidoTela.Boleto;
            //this.pedidoInfo = this.pedidoDataService.currentPurchaseInfoValue;
            this.visualizarBoletoService.arquivoBase64 =this.currentPurchasePaymentValue.pdf;
        } else {
            this.tipoPagamento = this.tipoMeioPagamentoPedidoTela.Saldo;
        }

        this.valorTotal = this.currentPurchaseValue.purchaseValue




    }

    ngOnDestroy() {
    }

    private loadInfo() {
        this.cedenteService.getAssignorInfo(this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId).subscribe(
            response => {
                this.assignorInfo = response.result;


                const tam = environment.TOTAL_CARACTERE_CNPJ - this.assignorInfo.document.toString().length;

                let str = this.assignorInfo.document.toString();

                if (this.currentPurchaseValue.paymentMethodId == 4)
                    this.loadQRCode();

                for (let i = 0; i < tam; i++) { str = '0' + str; }
                    this.assignorInfo.document = str;
            }, error => {
                this.alertService.error('Ocorreu um erro ao consultar as informações da empresa. Tente novamente mais tarde');
            }
        );


    }

    loadQRCode(){

        const depositoPixRequest = new GerarPixDinamico();
        depositoPixRequest.cnpjCedente = this.assignorInfo.document;
        depositoPixRequest.valor = this.currentPurchaseInfoValue.purchaseValue;
        depositoPixRequest.nomeCedente = this.assignorInfo.nickName;
        depositoPixRequest.numeroPedido = this.currentPurchasePaymentValue.identificador.toString();
        depositoPixRequest.cedenteGuid = this.currentUser.token.assignorGuid;
        depositoPixRequest.diasExpiracao = 20;
        this.transactionService.GerarPixDinamico(depositoPixRequest).subscribe(
            response => {
                if (response.status === ApiError.Sucesso) {

                this.qrCodePix = response.result;

                } else {
                this.alertService.error(response.message);
                }
            }, error => {
                this.alertService.error('Ocorreu um erro ao visualizar intenção de depósito');
            }
        );
    }

    showDetails(content: any, purchaseId: number) {
        this.router.navigate(['/portal/minhasrecargas/details/' + purchaseId]);
        /* this.modalService.open(content, { centered: true, size: 'lg' }); */
    }

    create() {
        this.pedidoDataService.deleteCurrentPedidoValue();
        this.pedidoDataService.deleteCurrentPedidoInfoValue();
        this.router.navigate(['create'], { relativeTo: this.route.parent });
    }

    calcValorProduto(){
        let auxValorProduto = 0;
        for (const s of this.currentPurchaseInfoValue.purchaseItens) {
            s.order.orderValue = 0
            for (let i = 0; i < s.order.orderItens.length; i++) {
                auxValorProduto += s.order.orderItens[i].referenceValue;
             }
        }
        return auxValorProduto;
    }

    abrirBoleto() {
        this.router.navigate(['portal/boleto']);
    }
}
